import PageHeader from '../components/PageHeader';
import useDocumentMeta from '../hooks/useDocumentMeta';
import { contactMethods, pageMeta } from '../data/site';
import styles from './Contact.module.scss';

const isExternal = (href) => !href.startsWith('mailto:');

function Contact() {
  useDocumentMeta(pageMeta['/contact']);

  return (
    <>
      <PageHeader
        eyebrow="Get in touch"
        title="Contact"
        intro="The quickest way to reach me is email — I read everything and reply to most."
      />

      <ul className={styles.list}>
        {contactMethods.map(({ id, label, value, href }) => {
          const external = isExternal(href);

          return (
            <li key={id}>
              <a
                href={href}
                className={styles.card}
                {...(external ? { target: '_blank', rel: 'noreferrer' } : {})}
              >
                <span className={styles.label}>{label}</span>
                <span className={styles.value}>{value}</span>

                <svg
                  className={styles.arrow}
                  viewBox="0 0 16 16"
                  width="16"
                  height="16"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    d="M3 8h10M9 4l4 4-4 4"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                {external && <span className="visually-hidden"> (opens in a new tab)</span>}
              </a>
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default Contact;
